var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFolderHollowZip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25012 4.62256C3.04302 4.62256 2.87512 4.79045 2.87512 4.99756V15.9976C2.87512 16.2047 3.04302 16.3726 3.25012 16.3726H16.7501C16.9572 16.3726 17.1251 16.2047 17.1251 15.9976V6.87256C17.1251 6.66545 16.9572 6.49756 16.7501 6.49756H10.0001C9.90067 6.49756 9.80528 6.45805 9.73496 6.38772L7.96979 4.62256H3.25012ZM2.12512 4.99756C2.12512 4.37624 2.6288 3.87256 3.25012 3.87256H8.12512C8.22458 3.87256 8.31996 3.91207 8.39029 3.98239L10.1555 5.74756H16.7501C17.3714 5.74756 17.8751 6.25124 17.8751 6.87256V15.9976C17.8751 16.6189 17.3714 17.1226 16.7501 17.1226H3.25012C2.6288 17.1226 2.12512 16.6189 2.12512 15.9976V4.99756Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9347 13.699V9.59814H13.3203C13.642 9.59814 13.905 9.65621 14.1093 9.77235C14.3148 9.88715 14.467 10.0427 14.5658 10.2389C14.6646 10.4351 14.714 10.6541 14.714 10.8957C14.714 11.1373 14.6646 11.3569 14.5658 11.5545C14.4684 11.752 14.3175 11.9095 14.1133 12.027C13.909 12.1432 13.6474 12.2012 13.3283 12.2012H12.3352V11.7607H13.3123C13.5326 11.7607 13.7095 11.7227 13.843 11.6466C13.9764 11.5705 14.0732 11.4677 14.1333 11.3382C14.1947 11.2074 14.2254 11.0599 14.2254 10.8957C14.2254 10.7315 14.1947 10.5846 14.1333 10.4552C14.0732 10.3257 13.9758 10.2242 13.8409 10.1508C13.7061 10.076 13.5272 10.0387 13.3043 10.0387H12.4313V13.699H11.9347Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.939 9.59814V13.699H10.4424V9.59814H10.939Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78233 13.699V13.3386L8.99294 10.0387H6.7583V9.59814H9.58565V9.95857L7.37503 13.2585H9.60967V13.699H6.78233Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64583 13.7309C5.54704 13.7309 5.46228 13.6955 5.39153 13.6247C5.32078 13.554 5.2854 13.4692 5.2854 13.3704C5.2854 13.2717 5.32078 13.1869 5.39153 13.1161C5.46228 13.0454 5.54704 13.01 5.64583 13.01C5.74461 13.01 5.82938 13.0454 5.90013 13.1161C5.97088 13.1869 6.00625 13.2717 6.00625 13.3704C6.00625 13.4358 5.98957 13.4959 5.95619 13.5506C5.92416 13.6054 5.88077 13.6494 5.82604 13.6828C5.77264 13.7148 5.71257 13.7309 5.64583 13.7309Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderHollowZip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder-hollow-zip.0b8362972781552ea9c5ff6f874e3351.svg";